import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as service from "./service";
import { analytics2, authenticate2 } from "../../../network/service";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getUser } from "../../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../../Redux/AToken/ATokenSlice";
import { useGoogleLogin } from "@react-oauth/google";
import { googleLogin, updateLoginWithoutCode } from "../Login/service";
import OtpModal from "../../../Components/Modals/OtpModal";
import SocialAccountLoginModal from "../../../Components/Modals/SocialAccountLoginModal";
import Translate, { useTranslateText } from "../../../Components/Multilanguage/Translate";
import { getLanguageModal } from "../../../Redux/LanguageModal/languageModalSlice";

const YowRegister = (props) => {
  const accessToken = useSelector((state) => state.accessToken?.value);
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const translateText = useTranslateText();

  const [values, setValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [otpModal, setOtpModal] = useState(false);
  const [userRegisterId, setUserRegisterId] = useState();
  const [redirectUrl, setRedirectUrl] = useState("/home");
  const [googleUser, setGoogleUser] = useState();
  const [socialLoginModalType, setSocialLoginModalType] = useState({});
  const [showSocialLoginModal, setShowSocialLoginModal] = useState(false);

  const [emailFormOpen, setEmailFormOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const appInfo = {
    accessToken: accessToken,
    projectDetails: projectInfo,
  };

  const subscriber = projectInfo?.projectConfig?.config?.SUBSCRIBER_BENEFITS;
  const pillarsData = subscriber?.pillars || [];
  const featuresData = subscriber?.features || [];
  const benefitsData = subscriber?.benefits || [];

  const showGoogle = true;
  // projectInfo?.projectConfig?.config?.GOOGLE_LOGIN_REQUIRED === "true" &&
  // projectInfo?.projectConfig?.config?.GOOGLE_CLIENT_ID;
  const showApple = true;
  // projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED === "true" &&
  // projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID;
  const showSocial = true;
  // projectInfo?.projectConfig?.config?.SOCIAL_LOGIN_REQUIRED === "true" &&
  // (showGoogle || showApple);

  useEffect(() => {
    if (!showSocial) {
      setEmailFormOpen(true);
    }
  }, [showSocial]);

  useEffect(() => {
    window.scroll(0, 0);
    if (props?.redirectPath) {
      setRedirectUrl(props.redirectPath);
    } else if (location?.state?.path) {
      setRedirectUrl(location?.state?.path);
    } else {
      setRedirectUrl("/home");
    }
  }, [location?.state, props?.redirectPath]);

  useEffect(() => {
    if (googleUser) {
      getGoogleUserData();
    }
  }, [googleUser]);

  const getGoogleUserData = async () => {
    const response = await googleLogin(googleUser?.access_token);
    if (response?.status === 200) {
      const values = {
        googleId: response?.data?.id,
        loginType: "google",
        firstName: response?.data?.name,
        email: response?.data?.email,
      };
      loginWithoutCode(values);
    }
  };

  const loginWithoutCode = async (values) => {
    const response = await updateLoginWithoutCode(appInfo, values);
    if (response?.status === 200) {
      localStorage.setItem("userId", response?.data?.data[0]?.user_id);
      if (response?.data?.data[0]?.user_email || values?.email) {
        localStorage.setItem("user_email", response?.data?.data[0]?.user_email || values?.email);
      }
      tokenAuthenticate();
      updateDeviceAnalytics(
        response?.data?.data[0]?.user_id,
        appInfo,
        response?.data?.data[0]?.user_email,
        response?.data?.data[0]?.first_name
      );
      dispatch(
        getUser({
          user: response?.data?.data[0]?.user_id,
        })
      );
      navigate(redirectUrl, { state: location?.state });
    } else if (response?.status === 204) {
      setSocialLoginModalType({
        heading: `Already registered with the same email. Do you want to link your ${values?.loginType} account?`,
        values: values,
      });
      setShowSocialLoginModal(true);
    }
  };

  const googleLoginHandler = useGoogleLogin({
    onSuccess: (codeResponse) => setGoogleUser(codeResponse),
    onError: (error) => { },
  });

  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED === "true" &&
      projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID
    ) {
      const script = document.createElement("script");
      script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.AppleID) {
          window.AppleID.auth.init({
            clientId: projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID,
            scope: "email name",
            redirectURI: projectInfo?.projectConfig?.config?.APPLE_LOGIN_REDIRECT_URL,
            usePopup: true,
          });

          document.addEventListener("AppleIDSignInOnSuccess", (event) => {
            const appleData = jwtDecode(event?.detail?.authorization?.id_token);
            if (appleData?.sub) {
              const { email, sub } = appleData;
              const name = email ? email.split("@")[0] : "User";
              const appleUserDetails = {
                appleId: sub,
                loginType: "apple",
                firstName: name,
                email,
              };
              loginWithoutCode(appleUserDetails);
            } else {
              toast.error(<Translate textKey={"try_again_msg"} />);
            }
          });

          document.addEventListener("AppleIDSignInOnFailure", (event) => {
            console.error("Apple Sign-in failed:", event.detail?.error);
          });
        }
      };

      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, []);

  const handleAppleClick = () => {
    if (window.AppleID && window.AppleID.auth) {
      window.AppleID.auth.signIn();
    } else {
      toast.error("Apple Sign-In is initializing. Please try again in a moment.");
    }
  };

  const updateDeviceAnalytics = async (userId, appInfo, userEmail, userName) => {
    await analytics2(userId, appInfo, userEmail, userName);
  };

  const tokenAuthenticate = async () => {
    const response = await authenticate2(appInfo);
    if (response?.status === 200) {
      localStorage.setItem("selectedLanguageCode", response?.data?.user_language?.short_code);
      localStorage.setItem("selectedLanguageId", response?.data?.user_language?.language_id);
      dispatch(
        getLanguageModal({
          languageModal: {
            selectedLanguageCode: response?.data?.user_language?.short_code,
          },
        })
      );
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
      dispatch(
        getUserDetails({
          userDetails: response?.data,
        })
      );
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    const keyMap = {
      first: "firstName",
      last: "lastName",
      email: "email",
      pw: "password",
      pw2: "confirmPassword",
    };
    const fieldName = keyMap[id] || id;
    setValues((prev) => ({ ...prev, [fieldName]: value }));
  };

  // Password strength calculation
  const scorePw = (v) => {
    if (!v) return 0;
    let s = 1;
    if (v.length >= 8) s++;
    if (/[A-Z]/.test(v) && /[a-z]/.test(v)) s++;
    if (/\d/.test(v) && /[^A-Za-z0-9]/.test(v)) s++;
    return Math.min(s, 4);
  };

  const pwScore = scorePw(values.password);
  const getPwLabel = (score) => {
    if (score >= 4) return <Translate textKey={"strong"} />;
    if (score === 3) return <Translate textKey={"good"} />;
    if (score >= 1) return <Translate textKey={"weak"} />;
    return "";
  };

  const okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(values.email);
  const okPw = values.password.length > 0;
  const okMatch = values.confirmPassword.length > 0 && values.password === values.confirmPassword;
  const okFirstName = values.firstName.trim().length > 0;
  const isFormValid = okEmail && okPw && okMatch && okFirstName;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isFormValid || submitting) return;
    setSubmitting(true);
    try {
      const response = await service.registerUser(appInfo, values);
      if (response?.status === 200) {
        localStorage.setItem("userId", response?.data?.data[0]?.user_id);
        toast.success(response?.data?.message, {
          position: "top-center",
        });
        setUserRegisterId(response?.data?.data[0]?.user_id);
        tokenAuthenticate();
        updateDeviceAnalytics(
          response?.data?.data[0]?.user_id,
          appInfo,
          values?.email,
          response?.data?.data[0]?.first_name
        );
        setTimeout(() => {
          dispatch(
            getUser({
              user: response?.data?.data[0]?.user_id,
            })
          );
        }, 1000);

        navigate(redirectUrl, {
          replace: true,
          state: { ...(location.state || {}), ...(props?.redirectState || {}) },
        });
      } else if (
        response?.status === 201 &&
        appInfo?.projectDetails?.projectConfig?.config?.REGISTRATION_OTP_REQUIRED === "true"
      ) {
        toast.success(response?.data?.message, {
          position: "top-center",
        });
        setOtpModal(true);
        setUserRegisterId(response?.data?.user_id);
      } else {
        toast.error(response?.data?.message || translateText("try_again_msg"), {
          position: "top-center",
        });
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || translateText("try_again_msg"), {
        position: "top-center",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const renderPillarIcon = (iconName) => {
    if (iconName === "clock") {
      return (
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 7v5l3.5 2" /><circle cx="12" cy="12" r="9" />
        </svg>
      );
    }
    if (iconName === "users") {
      return (
        <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="9" cy="8" r="3.2" /><path d="M2.5 19.5a6.5 6.5 0 0 1 13 0" />
          <circle cx="17.5" cy="9.5" r="2.4" /><path d="M16 15.4a5.6 5.6 0 0 1 5.5 4.1" />
        </svg>
      );
    }
    return (
      <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 5.5A1.5 1.5 0 0 1 4.5 4h15A1.5 1.5 0 0 1 21 5.5v10a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 15.5z" />
        <path d="M10 8.5l4.5 2.5L10 13.5z" fill="currentColor" stroke="none" />
        <path d="M8 20h8" />
      </svg>
    );
  };

  return (
    <div className="yowMemberContainer">
      {otpModal && (
        <OtpModal
          setOtpModal={setOtpModal}
          appInfo={appInfo}
          userRegisterId={userRegisterId}
          updateDeviceAnalytics={updateDeviceAnalytics}
          tokenAuthenticate={tokenAuthenticate}
          values={values}
          urlToRedirect={redirectUrl}
        />
      )}
      {showSocialLoginModal && (
        <SocialAccountLoginModal
          modalType={socialLoginModalType}
          setShowSocialLoginModal={setShowSocialLoginModal}
        />
      )}
      <ToastContainer />

      <div className="wrap">
        <div className="grid">
          <section className="pitch">
            {subscriber?.tagline && <span className="eyebrow">{subscriber.tagline}</span>}

            {subscriber?.title && (
              <h1>
                <span dangerouslySetInnerHTML={{ __html: subscriber.title }} />
              </h1>
            )}

            {subscriber?.description && <p className="lede">{subscriber.description}</p>}

            {pillarsData?.length > 0 && (
              <div className="pillars">
                {pillarsData?.map((pillar) => (
                  <article key={pillar.id} className={`pillar ${pillar.soon ? "pending" : ""}`}>
                    <span className="ico">{renderPillarIcon(pillar.icon)}</span>
                    <div>
                      <h3>
                        {pillar.title}{" "}
                        {pillar.soon && (
                          <span className="soon">
                            {pillar?.soon}
                          </span>
                        )}
                      </h3>
                      <p>{pillar.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            )}

            {featuresData?.length > 0 && benefitsData?.length > 0 && (
              <div className="unlock">
                <table>
                  <thead>
                    <tr>
                      <th>
                        {subscriber?.table_title}
                      </th>
                      {benefitsData?.map((b, i) => (
                        <th key={b.title || i} className={i === (benefitsData?.length ?? 0) - 1 ? "mem" : ""}>
                          {b.title}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {featuresData?.map((feat) => {
                      const isCostRow = feat.id === "price";
                      return (
                        <tr key={feat.id} className={isCostRow ? "cost" : ""}>
                          <td>
                            {feat.title}{" "}
                            {feat.soon && (
                              <span className="soon">
                                {feat?.soon}
                              </span>
                            )}
                          </td>
                          {benefitsData?.map((b, i) => {
                            const feats = b?.features || [];
                            const entry = feats.find((f) => (typeof f === "string" ? f === feat.id : f && f.id === feat.id));
                            const isLastCol = i === (benefitsData?.length ?? 0) - 1;
                            const cellClass = `${isLastCol ? "mem " : ""}${entry ? "yes" : "no"}`;

                            if (isCostRow) {
                              return (
                                <td key={b.title + i} className={isLastCol ? "mem" : ""}>
                                  {entry?.value || "$0"}
                                </td>
                              );
                            }

                            return (
                              <td key={b.title + i} className={cellClass}>
                                {entry ? "✓" : "—"}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </section>

          <aside className="formCard">
            {subscriber?.form_title && <h2>{subscriber.form_title}</h2>}
            {subscriber?.form_subtitle && <p className="sub">{subscriber.form_subtitle}</p>}

            {showSocial && (
              <>
                {showGoogle && (
                  <button className="authBtn googleBtn" type="button" onClick={() => googleLoginHandler()}>
                    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
                      <path fill="#EA4335" d="M24 9.5c3.5 0 6.6 1.2 9 3.6l6.7-6.7C35.6 2.6 30.2.5 24 .5 14.6.5 6.5 5.9 2.6 13.7l7.8 6.1C12.3 13.6 17.6 9.5 24 9.5z" />
                      <path fill="#4285F4" d="M46.5 24.5c0-1.6-.1-3.2-.4-4.7H24v9h12.7c-.6 3-2.3 5.5-4.8 7.2l7.6 5.9c4.4-4.1 7-10.1 7-17.4z" />
                      <path fill="#FBBC05" d="M10.4 28.2a14.6 14.6 0 0 1 0-8.4l-7.8-6.1a24 24 0 0 0 0 20.6l7.8-6.1z" />
                      <path fill="#34A853" d="M24 47.5c6.2 0 11.5-2 15.3-5.6l-7.6-5.9c-2.1 1.4-4.8 2.3-7.7 2.3-6.4 0-11.7-4.1-13.6-9.9l-7.8 6.1C6.5 42.1 14.6 47.5 24 47.5z" />
                    </svg>
                    <Translate textKey={"google_sign_in"} />
                  </button>
                )}

                {showApple && (
                  <button className="authBtn appleBtn" type="button" onClick={handleAppleClick}>
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                      <path d="M17.05 12.54c-.03-2.79 2.28-4.13 2.38-4.2-1.3-1.9-3.32-2.16-4.04-2.19-1.72-.17-3.36 1.01-4.23 1.01-.87 0-2.22-.99-3.65-.96-1.88.03-3.61 1.09-4.58 2.77-1.95 3.38-.5 8.38 1.4 11.12.93 1.34 2.04 2.85 3.49 2.79 1.4-.06 1.93-.9 3.62-.9s2.17.9 3.65.87c1.51-.03 2.46-1.37 3.38-2.71 1.06-1.56 1.5-3.07 1.53-3.15-.03-.01-2.94-1.13-2.97-4.48z" />
                      <path d="M14.28 4.32c.77-.93 1.29-2.22 1.15-3.5-1.11.05-2.45.74-3.24 1.67-.71.82-1.33 2.14-1.16 3.4 1.24.1 2.5-.63 3.25-1.57z" />
                    </svg>
                    <Translate textKey={"apple_sign_in"} />
                  </button>
                )}

                <div className="divider">
                  <Translate textKey={"or"} />
                </div>
              </>
            )}

            <button
              className={`authBtn emailBtn ${emailFormOpen ? "open" : ""}`}
              id="emailToggle"
              type="button"
              aria-expanded={emailFormOpen}
              aria-controls="emailForm"
              onClick={() => setEmailFormOpen(!emailFormOpen)}
            >
              <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2.5" y="5" width="19" height="14" rx="2.5" /><path d="M3 7l9 6 9-6" />
              </svg>
              <Translate textKey={"register_via_email"} />
              <svg className="chev" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </button>

            <form
              className={`emailForm ${emailFormOpen ? "open" : ""}`}
              id="emailForm"
              onSubmit={handleSubmit}
            >
              <div className="row2">
                <div className="field">
                  <input
                    id="first"
                    type="text"
                    placeholder={translateText("first_name")}
                    autoComplete="given-name"
                    value={values.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="field">
                  <input
                    id="last"
                    type="text"
                    placeholder={translateText("last_name")}
                    autoComplete="family-name"
                    value={values.lastName}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="field">
                <input
                  id="email"
                  type="email"
                  className={values.email ? (okEmail ? "valid" : "invalid") : ""}
                  placeholder={translateText("email")}
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                />
                <div className="hint bad" id="emailHint">
                  {!okEmail && values.email ? translateText("valid_email_message") : ""}
                </div>
              </div>

              <div className="field">
                <input
                  id="pw"
                  type={showPassword ? "text" : "password"}
                  placeholder={translateText("password")}
                  autoComplete="new-password"
                  value={values.password}
                  onChange={handleChange}
                />
                <button
                  className="peek"
                  id="peek"
                  type="button"
                  aria-label="Password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7z" /><circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                <div className={`meter ${values.password ? `s${pwScore}` : ""}`} id="meter">
                  <i></i><i></i><i></i><i></i>
                </div>
                <div className={`hint ${values.password ? (pwScore >= 3 ? "good" : "") : ""}`} id="pwHint">
                  {values.password ? getPwLabel(pwScore) : ""}
                </div>
              </div>

              <div className="field">
                <input
                  id="pw2"
                  type={showPassword ? "text" : "password"}
                  className={values.confirmPassword ? (okMatch ? "valid" : "invalid") : ""}
                  placeholder={translateText("confirm_password")}
                  autoComplete="new-password"
                  value={values.confirmPassword}
                  onChange={handleChange}
                />
                <div className="hint bad" id="pw2Hint">
                  {values.confirmPassword && !okMatch ? <Translate textKey={"password_not_matching_message"} /> : ""}
                </div>
              </div>

              <button className="submit" id="submit" type="submit" disabled={!isFormValid || submitting}>
                {submitting
                  ? translateText("processing") + "..."
                  : translateText("create_account")}
              </button>
            </form>

            {subscriber?.payment_note && (
              <p className="reassure">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 12.5l5.5 5.5L20 6.5" />
                </svg>
                {subscriber.payment_note}
              </p>
            )}
            <p className="legal">
              <Translate textKey={'register_agree_text'} /><br /> <span onClick={() => navigate("/terms-and-conditions")}><Translate textKey={'terms_of_use'} /></span>{" "}
              <Translate textKey={'and'} /><span onClick={() => navigate("/privacy-policy")}> <Translate textKey={'privacy_policy'} /></span>
            </p>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default YowRegister;
